import { render, staticRenderFns } from "./FactureFournisseurModal.vue?vue&type=template&id=20424cd0"
import script from "./FactureFournisseurModal.vue?vue&type=script&lang=ts"
export * from "./FactureFournisseurModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports